import type { GroupCategory } from '@/types/support';

export const GROUP_CATEGORIES: Record<GroupCategory, string> = {
  Exercises: '🏃‍♂️',
  Nutrition: '🥗',
  Sleep: '😴',
  Stress: '😰',
  Relations: '❤️',
  Addictions: '📱'
};

export const AVAILABLE_CATEGORIES: GroupCategory[] = [
  'Exercises',
  'Nutrition',
  'Sleep',
  'Stress',
  'Relations',
  'Addictions'
];